"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeType = void 0;
var AttributeType;
(function (AttributeType) {
    AttributeType["Text"] = "text";
    AttributeType["HTML"] = "html";
    AttributeType["Media"] = "media";
    AttributeType["Icon"] = "icon";
    AttributeType["Number"] = "number";
    AttributeType["Boolean"] = "boolean";
    AttributeType["Array"] = "array";
    AttributeType["Object"] = "object";
    AttributeType["Form"] = "form";
    AttributeType["Link"] = "link";
    AttributeType["Menu"] = "menu";
})(AttributeType = exports.AttributeType || (exports.AttributeType = {}));
